import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';

// Realtime must not pull the lazy import/SDK implementation into startup.
export const contactImportChannelsKey = (scope = sessionScope(useAuthStore.getState())) => ['contact-import-channels', scope] as const;
